import {
	IconSize50,
	IconSize75,
	IconSize100,
	IconSize150,
	IconSize200,
	IconSize300,
	IconSize400,
	IconSize500,
	IconSize625,
	IconSize750,
} from "@mv/design-tokens/variables";
import { type SVGProps } from "react";
export interface Props
	extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
	size?:
		| "50"
		| "75"
		| "100"
		| "150"
		| "200"
		| "300"
		| "400"
		| "500"
		| "625"
		| "750";
}
const sizeMap = {
	50: IconSize50,
	75: IconSize75,
	100: IconSize100,
	150: IconSize150,
	200: IconSize200,
	300: IconSize300,
	400: IconSize400,
	500: IconSize500,
	625: IconSize625,
	750: IconSize750,
};
export default function IconSimSwitch({ size = "100", ...props }: Props) {
	return (
		<svg
			xmlns={"http://www.w3.org/2000/svg"}
			{...props}
			viewBox="0 0 24 24"
			width={sizeMap[size]}
			height={sizeMap[size]}
		>
			<g fill="none" fillRule="nonzero">
				<path
					fill="#FEFEFE"
					d="M3.235 17.341a.45.45 0 0 1 .614-.035l.02.019 3.085 2.927a.45.45 0 0 1-.597.67l-.022-.018-3.084-2.928a.45.45 0 0 1-.016-.635M10.757 5.217H6.243c-.747 0-1.353.606-1.353 1.353v5.312c0 .747.606 1.353 1.353 1.353h4.514c.747 0 1.352-.606 1.352-1.353V6.57c0-.747-.605-1.353-1.352-1.353m-4.514.898h4.514c.25 0 .454.204.454.455v5.312a.455.455 0 0 1-.454.455H6.243a.455.455 0 0 1-.455-.455V6.57c0-.25.204-.455.455-.455"
				/>
				<path
					fill="#FEFEFE"
					d="M12.494 3.074c.803 0 1.427.715 1.447 1.574v8.368a.45.45 0 0 1-.897.026V4.69c0-.4-.249-.7-.526-.718H4.56c-.278 0-.534.29-.549.683v12.801l2.814 2.672h5.67c.233 0 .456-.205.526-.518l.007-.034a.45.45 0 0 1 .883.163c-.133.721-.692 1.267-1.377 1.287H6.465l-3.354-3.184V4.691c0-.864.611-1.593 1.408-1.616h7.975"
				/>
				<path
					fill="#E42822"
					d="M16.258 14.794a.45.45 0 0 1 .607-.101l.022.016 1.645 1.25 1.717-1.254a.45.45 0 0 1 .61.076l.017.021a.45.45 0 0 1-.076.611l-.021.017-1.987 1.452a.45.45 0 0 1-.513.012l-.024-.017-1.911-1.453a.45.45 0 0 1-.086-.63M11.082 15.805a.45.45 0 0 1 .513-.012l.024.018 1.911 1.452a.45.45 0 0 1-.521.731l-.023-.015-1.644-1.25-1.717 1.254a.45.45 0 0 1-.61-.076l-.017-.022a.45.45 0 0 1 .076-.61l.021-.018z"
				/>
				<g fill="#E42822">
					<path d="M11.31 15.894a.45.45 0 0 1 .448.45 3.179 3.179 0 0 0 5.938 1.58.45.45 0 0 1 .779.447 4.077 4.077 0 0 1-7.615-2.028.45.45 0 0 1 .45-.449M14.937 12.266a4.077 4.077 0 0 1 4.077 4.077.45.45 0 0 1-.899 0 3.179 3.179 0 0 0-5.837-1.742.45.45 0 0 1-.751-.493 4.07 4.07 0 0 1 3.41-1.842" />
				</g>
			</g>
		</svg>
	);
}
